import * as React from "react"
import { Link } from "gatsby";
import {hoverButton} from './shared.module.scss'
import { getYardiPropIdFromSlug } from '../utils/propertyMapUtil';


const ApplyButton = ({slug, communityName = null, text="Apply Now",marginRight="1rem",isInHeader="true"})=>{
    //console.log("slug from within applyButton ",slug);

    // Define the set of propids that should use the transition page
    const transitionTestGroupPropIds = new Set(['vita', 'harbor', 'golfla12', 'medical']);

    const links = {
        'amalfi' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=amalfi",
        'aria' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=aria",
        'aspen' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=aspen",
        'azure' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=azure",
        'bayshore' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=bayshore",
        'beachfl1' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=beachfl1&pg=beachfl2&pg=beachfl3",
        'bellagio' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=bellagio",
        'brooklyn' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=brooklyn",
        'capri' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=capri",
        'bella-capri' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=capri",
        'carlyle' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=carlyle",
        'casa' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=casa",
        'celano' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=celano",
        'coconut' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=coconut",
        'conway' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=conway",
        'conway-forest' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=conway",
        'eusonia' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=eusonia",
        'evergree' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=evergree",
        'fred' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=fred",
        'glenhill' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=glenhill",
        'gleno1' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=gleno1",
        'golfla12' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=golfla12&pg=golfla03",
        'harbor' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=harbor",
        'harper' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=harper",
        'hillcres' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=hillcres",
        'hydepark' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=hydepark",
        'indigo' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=indigo",
        'iris' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=iris",
        'ivyflats' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=ivyflats",
        'manflats' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=manflats",
        'manwest' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=manwest",
        'mcdonald' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=mcdonald",
        'meadow' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=meadow",
        'medical' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=medical",
        'monterey' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=monterey",
        'olivia' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=olivia",
        'palio' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=palio",
        'parkland' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=parkland",
        'parkplac' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=parkplac",
        'piccflat' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=piccflat",
        'pines' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=pines",
        'porto' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=porto",
        'positano' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=positano",
        'riva' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=riva",
        'roundtre' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=roundtre",
        'sapphire' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=sapphire",
        'sc1' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=sc1&pg=sc2",
        'sc2' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=sc1&pg=sc2",
        'sc3' : "https://mckinley.findigs.com/apply/unitid=823cf8c5-d22d-40b4-8fcc-f8ef9baaaed7?pg=sc3",
        'schoofla' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=schoofla",
        'serena' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=serena",
        'spruce' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=spruce",
        'statestr' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=statestr",
        'studio' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=studio",
        'tracourt' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=tracourt",
        'tracross' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=tracross",
        'traheigh' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=traheigh",
        'traridge' : "https://mckinley.findigs.com/apply/unitid=d4d188fd-931e-4b67-a5a3-b98e0f4e3e50?pg=traridge",
        'villas' : "https://mckinley.findigs.com/apply/unitid=e0256e12-bd40-4cb5-b7fd-35b6859b9800?pg=villas",
        'vita' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=vita",
        'wesley' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=wesley",
        'westfla1': "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=westfla1&pg=westfla2",
        'westwood' : "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=westwood",
        'willfla1': "https://mckinley.findigs.com/apply/unitid=beb334f6-8fb7-47bf-9a8d-e0483006e51b?pg=willfla1&pg=willfla2"
    }
    
    //console.log('Slug: ' + slug);
    const propid = getYardiPropIdFromSlug(slug);
    //console.log('propid '+propid);

    // Determine if this button instance should use the transition page
    const useTransitionPage = transitionTestGroupPropIds.has(propid);

    const findigsUrl = propid in links ? links[propid] : 'https://mckinley.findigs.com/apply';

    // We only need the specific stopPropagation for the <a> tag case now.
    // The Gatsby Link onClick below handles the transition page case.
    const handleAnchorClick = (event) => {
        event.stopPropagation();
    };

    const targetUrl = useTransitionPage
        ? `/apply-now?targetUrl=${encodeURIComponent(findigsUrl)}&communityName=${encodeURIComponent(communityName || '')}`
        : findigsUrl;

    const commonProps = {
        className: isInHeader ? "button is-link navbar-item "+hoverButton : "button is-small is-warning",
        id: isInHeader ? "app_now_btn" : "map_app_button",
        style: isInHeader ? {marginRight:marginRight,position:'relative',top:'0.9rem',outline:'#4E6F92 1px solid',display:'inline-block'} : {},
        // onClick is handled differently for Link vs a tag below
    };

    return useTransitionPage ? (
        // Add stopPropagation directly to the Link component
        <a href={targetUrl} {...commonProps} onClick={handleAnchorClick} target="_blank" rel="noopener noreferrer">
            {text}
        </a>
    ) : (
        // Use the specific handler for the anchor tag
        <a href={targetUrl} {...commonProps} onClick={handleAnchorClick} target="_blank" rel="noopener noreferrer">
            {text}
        </a>
    );
}

export default ApplyButton
